export default class Validation {
    constructor (field, hint, type, required, hints = true) {
        this.field = field;
        this.hint = hint;
        this.type = type;
        this.required = required;
        this.hints = hints;
    }

    validateRequired (value) {
        if (this.required) {
            if (!value) {
                this.hint.textContent = 'This field is required';
    
                this.field.setAttribute('data-error', true);

                if (this.hints) this.field.classList.add('site-field--error');
            } else {
                this.hint.textContent = '';
    
                this.field.removeAttribute('data-error');

                if (this.hints) this.field.classList.remove('site-field--error');
            }
        }
    }

    validateName (value) {
        if (value) {
            const reName = /^[a-zA-Z\s]+$/;

            const valid = reName.test(value.trim().toLowerCase());

            if (!valid) {
                this.hint.textContent = 'Please enter a valid name';
                
                this.field.setAttribute('data-error', true);

                if (this.hints) this.field.classList.add('site-field--error');
            } else {
                this.hint.textContent = '';
                
                this.field.removeAttribute('data-error');

                if (this.hints) this.field.classList.remove('site-field--error');
            }
        }
    }

    validateEmail (value) {
        if (value) {
            const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            const valid = re.test(value.trim().toLowerCase());
            
            if (!valid) {
                this.hint.textContent = 'Please enter a valid email address';
                
                this.field.setAttribute('data-error', true);

                if (this.hints) this.field.classList.add('site-field--error');
            } else {
                this.hint.textContent = '';
                
                this.field.removeAttribute('data-error');

                if (this.hints) this.field.classList.remove('site-field--error');
            }
        }
    }

    validatePhone (value) {
        if (value && value.length > 3) {
            const re = /^\d+$/;
            const valid = re.test(value.replaceAll('+', '').replaceAll(' ', '').replaceAll('(', '').replaceAll(')', '').replaceAll('-', ''));

            if (!valid) {
                this.hint.textContent = 'Please enter a valid phone number';
                
                this.field.setAttribute('data-error', true);

                if (this.hints) this.field.classList.add('site-field--error');
            } else if (valid && (value.replaceAll(' ', '')).length > 20) {
                this.hint.textContent = 'Please enter a valid phone number';
                
                this.field.setAttribute('data-error', true);

                if (this.hints) this.field.classList.add('site-field--error');
            } else {
                this.hint.textContent = '';
                
                this.field.removeAttribute('data-error');

                if (this.hints) this.field.classList.remove('site-field--error');
            }
        }
    }

    validateCard (value) {
        const re = /^\d{16}$/;
        const valid = re.test(value.replaceAll(' ', ''));

        if (value && !valid) {
            this.hint.textContent = 'Please enter a valid card number';
            
            this.field.setAttribute('data-error', true);
            if (this.hints) this.field.classList.add('site-field--error');
        } else {
            this.hint.textContent = '';
            
            this.field.removeAttribute('data-error');
            if (this.hints) this.field.classList.remove('site-field--error');
        }
    }

    validatePassword (value, compare = null) {
        if (value) {
            const valid = value.length >= 8;

            if (!valid) {
                this.hint.textContent = 'Password must be at least 8 characters';

                this.field.setAttribute('data-error', true);

                if (this.hints) this.field.classList.add('site-field--error');
            } else {
                this.hint.textContent = '';
                
                this.field.removeAttribute('data-error');

                if (this.hints) this.field.classList.remove('site-field--error');
            }

            if (compare) {
                const match = value === compare;

                if (!match) {
                    this.hint.textContent = 'Passwords do not match';

                    this.field.setAttribute('data-error', true);
    
                    if (this.hints) this.field.classList.add('site-field--error');
                } else {
                    this.hint.textContent = '';
                    
                    this.field.removeAttribute('data-error');
    
                    if (this.hints) this.field.classList.remove('site-field--error');
                }
            }
        }
    }

    validatePasswordConfirmation (value, compare = null) {
        if (value) {
            const valid = value === compare;

            if (!valid) {
                this.hint.textContent = 'Passwords do not match';

                this.field.setAttribute('data-error', true);

                if (this.hints) this.field.classList.add('site-field--error');
            } else {
                this.hint.textContent = '';
                
                this.field.removeAttribute('data-error');

                if (this.hints) this.field.classList.remove('site-field--error');
            }
        }
    }

    validateNumber (value) {
        if (value) {
            const re = /^\d+$/;
            const valid = re.test(value) && Number(value) <= 100000;

            if (!valid || value <= 0) {
                this.hint.textContent = 'Please enter a valid amount up to £ 100,000';
                
                this.field.setAttribute('data-error', true);

                if (this.hints) this.field.classList.add('site-field--error');
            } else {
                this.hint.textContent = '';
                
                this.field.removeAttribute('data-error');

                if (this.hints) this.field.classList.remove('site-field--error');
            }
        }
    }

    validateNumberMin (value, min = 0) {
        if (value) {
            const re = /^\d+$/;
            const valid = re.test(value) && Number(value) >= min && Number(value) <= 100000;

            if (!valid || value <= 0) {
                this.hint.textContent = `Please enter a valid amount more than £ ${min} and up to £ 100,000`;
                
                this.field.setAttribute('data-error', true);

                if (this.hints) this.field.classList.add('site-field--error');
            } else {
                this.hint.textContent = '';
                
                this.field.removeAttribute('data-error');

                if (this.hints) this.field.classList.remove('site-field--error');
            }
        }
    }

    validateUser (value) {
        if (value) {
            const reName = /^[a-zA-Z\s]+$/;
            const reEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            const valid = reName.test(value.trim().toLowerCase()) || reEmail.test(value.trim().toLowerCase());

            if (!valid) {
                this.hint.textContent = 'Please enter a valid name or email address';
                
                this.field.setAttribute('data-error', true);

                if (this.hints) this.field.classList.add('site-field--error');
            } else {
                this.hint.textContent = '';
                
                this.field.removeAttribute('data-error');

                if (this.hints) this.field.classList.remove('site-field--error');
            }
        }
    }

    validateTitle (value) {
        if (value) {
            const re = /^[a-zA-Z0-9\s\-',.!£:;"]+$/;

            const valid = re.test(value.trim().toLowerCase());
            const validMax = value.length ? value.length <= 80 : true;

            if (!valid) {
                this.hint.textContent = 'You are using an invalid character in your title';
                
                this.field.setAttribute('data-error', true);

                if (this.hints) this.field.classList.add('site-field--error');
            } else if (valid && !validMax) {
                this.hint.textContent = 'Title must contain no more than 80 characters';

                this.field.setAttribute('data-error', true);

                if (this.hints) this.field.classList.add('site-field--error');
            } else {
                this.hint.textContent = '';

                this.field.removeAttribute('data-error');

                if (this.hints) this.field.classList.remove('site-field--error');
            }
        }
    }

    validateDescription (value) {
        if (value) {
            const validMax = value.length ? value.length <= 2500 : true;

            if (!validMax) {
                this.hint.textContent = 'Description must contain no more than 2500 characters';

                this.field.setAttribute('data-error', true);

                if (this.hints) this.field.classList.add('site-field--error');
            } else {
                this.hint.textContent = '';

                this.field.removeAttribute('data-error');

                if (this.hints) this.field.classList.remove('site-field--error');
            }
        }
    }

    validateDetails (value) {
        if (value) {
            const validMax = value.length ? value.length <= 800 : true;

            if (!validMax) {
                this.hint.textContent = 'Description must contain no more than 800 characters';

                this.field.setAttribute('data-error', true);

                if (this.hints) this.field.classList.add('site-field--error');
            } else {
                this.hint.textContent = '';

                this.field.removeAttribute('data-error');

                if (this.hints) this.field.classList.remove('site-field--error');
            }
        }
    }

    validateRating (field) {
        const inputs = field.querySelectorAll('input');

        const valid = !inputs[0].checked && [...inputs].some((input) => input.value && input.checked);

        if (!valid) {
            this.hint.textContent = 'Please select a rating';
            
            this.field.setAttribute('data-error', true);

            if (this.hints) this.field.classList.add('site-field--error');
        } else {
            this.hint.textContent = '';
            
            this.field.removeAttribute('data-error');

            if (this.hints) this.field.classList.remove('site-field--error');
        }

        [...inputs].forEach((input) => {
            input.addEventListener('change', () => {
                this.validateRating(field);
            });
        });
    }

    validateTime (field) {
        const input = field.querySelector('input');

        const { value } = input;

        if (!value) {
            this.hint.textContent = 'This field is required';

            this.field.setAttribute('data-error', true);

            if (this.hints) this.field.classList.add('site-field--error');
        } else {
            this.hint.textContent = '';

            this.field.removeAttribute('data-error');

            if (this.hints) this.field.classList.remove('site-field--error');
        }
    }
}
